import { Component, Input } from '@angular/core';
import { FormArray, FormBuilder, Validators } from '@angular/forms';
import { Segment } from '@core/interfaces';

@Component({
  selector: 'tab-forms',
  styleUrls: ['tab-forms.component.scss'],
  templateUrl: './tab-forms.component.html'
})
export class TabFormsComponent {
  @Input()
  public isViewMode: boolean;

  @Input()
  public selectedSegment: Segment;

  @Input()
  public segmentMaintenanceFormsArray: FormArray;

  @Input()
  public isDuplicatedForm = false;

  constructor(private formBuilder: FormBuilder) { }

  addForm(): void {
    const segmentTypeMaintenanceForm = this.formBuilder.group({
      form: this.formBuilder.control(null, [Validators.required]),
      requiredComplete: this.formBuilder.control(false),
      requiredReport: this.formBuilder.control(false),
      requiredStart: this.formBuilder.control(false),
      maintenanceType: this.formBuilder.control(null, [Validators.required]),
    });

    this.segmentMaintenanceFormsArray.setControl(this.segmentMaintenanceFormsArray.controls.length, segmentTypeMaintenanceForm);

    if (this.isViewMode) {
      this.segmentMaintenanceFormsArray.disable();
    }
  }

  removeForm(index: number): void {
    this.segmentMaintenanceFormsArray.removeAt(index);
  }
}
